import React from 'react';
import { Search, X, SlidersHorizontal } from 'lucide-react';

const WISH_TYPES = [
  { value: '', label: 'Sve vrste' },
  { value: 'prodaja', label: 'Prodaja' },
  { value: 'kupovina', label: 'Kupovina' },
  { value: 'razmena', label: 'Razmena' },
];

const SORT_OPTIONS = [
  { value: 'newest', label: 'Najnoviji' },
  { value: 'oldest', label: 'Najstariji' },
  { value: 'price_asc', label: 'Cena: rastuće' },
  { value: 'price_desc', label: 'Cena: opadajuće' },
];

export default function ArchiveFilters({ filters, onFiltersChange }) {
  const handleChange = (key, value) => {
    onFiltersChange?.({ ...filters, [key]: value });
  };

  const hasActiveFilters = filters?.search || filters?.wishType || filters?.sortBy !== 'newest';

  const clearFilters = () => {
    onFiltersChange?.({ search: '', wishType: '', sortBy: 'newest' });
  };

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4">
      <div className="flex flex-wrap gap-3 items-center">
        {/* Search */}
        <div className="relative flex-1 min-w-[200px]">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Pretraži oglase..."
            value={filters?.search || ''}
            onChange={(e) => handleChange('search', e?.target?.value)}
            className="w-full pl-9 pr-4 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
          />
          {filters?.search && (
            <button
              onClick={() => handleChange('search', '')}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
            >
              <X size={14} />
            </button>
          )}
        </div>

        {/* Type filter */}
        <select
          value={filters?.wishType || ''}
          onChange={(e) => handleChange('wishType', e?.target?.value)}
          className="px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 bg-white text-gray-700"
        >
          {WISH_TYPES?.map(opt => (
            <option key={opt?.value} value={opt?.value}>{opt?.label}</option>
          ))}
        </select>

        {/* Sort */}
        <div className="flex items-center gap-2">
          <SlidersHorizontal size={15} className="text-gray-400" />
          <select
            value={filters?.sortBy || 'newest'}
            onChange={(e) => handleChange('sortBy', e?.target?.value)}
            className="px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 bg-white text-gray-700"
          >
            {SORT_OPTIONS?.map(opt => (
              <option key={opt?.value} value={opt?.value}>{opt?.label}</option>
            ))}
          </select>
        </div>

        {/* Clear filters */}
        {hasActiveFilters && (
          <button
            onClick={clearFilters}
            className="flex items-center gap-1.5 px-3 py-2 text-sm text-gray-500 hover:text-gray-700 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <X size={14} />
            Poništi
          </button>
        )}
      </div>
    </div>
  );
}
